import React, {Component} from 'react';
import {Row, Col, FormGroup, Form, ButtonToolbar} from "react-bootstrap";
import {TopButtonAction, TopButtonCancel} from "../../../../../../../componentsTopsa/buttons/TopButtons";
import ObsadaService from "../../../ObsadaService";

export default class KalendarzModalZmienStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            event: this.props.event,
            czyZapisano: null,
        };
        this.onClickOdwolaj = this.onClickOdwolaj.bind(this)
        this.onClickZmienStatus = this.onClickZmienStatus.bind(this)
    }

    componentDidMount() {
        this.setState({event: this.props.event})
    }

    componentWillReceiveProps(nextprops) {
        this.setState({
            event: nextprops.event,
        })
    }

    renderStatusKursu() {
        if (this.state.event.zablokowane === 0) {
            return <span style={{color: 'forestgreen'}}><i className={'fa fa-check'}></i> dostępny</span>
        }
        else if (this.state.event.zablokowane === 1) {
            return <span style={{color: 'darkorange'}}><i className={'fa fa-times'}></i> zablokowany</span>
        }
        else if (this.state.event.zablokowane === 2) {
            return <span style={{color: 'firebrick'}}><i className={'fa fa-repeat'}></i> odwołany</span>
        }
    }

    onClickOdwolaj() {
        ObsadaService.odwolajObsade(this.state.event.id_ob).then(function (response) {
            if (response.status < 300) {
                this.setState({czyZapisano: true})
                setTimeout(function () {
                    this.props.afterClickZapisz(this.state.event,'odwolaj');
                }.bind(this), 100)
            }
            else {
                this.setState({czyZapisano: false})
            }
        }.bind(this))
    }

    onClickZmienStatus() {
        if (this.state.event.zablokowane == 0) {
            // dostepny -> zmiana na niedostepny
            ObsadaService.zablokujKurs(this.state.event.id_ob).then(function (response) {
                if (response.status < 300) {
                    this.setState({czyZapisano: true})
                    setTimeout(function () {
                        this.props.afterClickZapisz(this.state.event,'zablokuj');
                    }.bind(this), 1)
                }
                else {
                    this.setState({czyZapisano: false})
                }
            }.bind(this))
        } else {
            // niedostepny -> zmiana na dostepny
            ObsadaService.odblokujKurs(this.state.event.id_ob).then(function (response) {
                if (response.status < 300) {
                    this.setState({czyZapisano: true})
                    setTimeout(function () {
                        this.props.afterClickZapisz(this.state.event,'odblokuj');
                    }.bind(this), 1)
                }
                else {
                    this.setState({czyZapisano: false})
                }
            }.bind(this))
        }
    }

    render() {

        return (
            <div>
                {
                    (this.state.czyZapisano === null) ?
                        <div>
                            <h3 style={{textAlign: 'center'}}>
                                Kurs nr <span className={'label label-ebus-primary'} style={(this.state.event.zablokowane == 2) ? {
                                fontSize: 'inherit',
                                background: 'grey'
                            } : {fontSize: 'inherit'}}>{this.state.event.id_ku}</span> {this.renderStatusKursu()}
                            </h3>
                            <div style={{marginTop: '25px'}}>
                                {
                                    (this.props.modalTyp === 'odwolaj') ?
                                        <h4 style={{textAlign: 'left'}}>Czy na pewno odwołać kurs?
                                            <small style={{marginLeft: '10px'}}>Akcji nie można cofnąć, a opcje duplikowania oraz zmiany zasobów
                                                zostaną
                                                zablokowane.</small>
                                        </h4>
                                        :
                                        <h4 style={{textAlign: 'left'}}>Czy na pewno zmienić status na {(this.props.modalTyp === 'odblokuj') ?
                                            <span style={{color: 'forestgreen'}}><i className={'fa fa-check'}></i> dostępny</span> :
                                            <span style={{color: 'darkorange'}}><i className={'fa fa-times'}></i> zablokowany</span>} ?
                                            <small style={{marginLeft: '10px'}}>Akcję można cofnąć.</small>
                                        </h4>
                                }
                            </div>
                            <div style={{marginTop: '25px'}}>
                                <ButtonToolbar style={{margin: "0 auto", width: "250px"}}>
                                    <TopButtonCancel onClick={() => {
                                        this.props.onClickAnuluj()
                                    }}/>
                                    {
                                        (this.props.modalTyp === 'odwolaj') ?
                                            <TopButtonAction text={'Odwołaj kurs'} className={'btn-status-odwolany'} btnColor={'default'}
                                                             iconType={'fa fa-repeat'} btnSize={'md'} onClick={this.onClickOdwolaj}/>
                                            :
                                            <TopButtonAction text={'Zmień status'} className={'btn-innertext-color-blue'} btnColor={'default'}
                                                             iconType={'fa fa-retweet'} btnSize={'md'} onClick={this.onClickZmienStatus}/>
                                    }
                                </ButtonToolbar>
                            </div>
                        </div>
                        :
                        <div>
                            {
                                (this.state.czyZapisano) ?
                                    <h3>
                                        <i className={'fa fa-check'} style={{color: 'forestgreen'}}></i> Pomyślnie zapisano zmiany
                                        <div>
                                            <small><i className={'fa fa-circle-o-notch fa-spin'}></i> Za chwilę nastąpi odświeżenie kalendarza...
                                            </small>
                                        </div>
                                    </h3>
                                    :
                                    <h3>
                                        <i className={'fa fa-times'} style={{color: 'firebrick'}}></i> Wystąpił błąd podczas akcji
                                    </h3>
                            }
                        </div>
                }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/obsada/ObsadaKalendarz/components/modalComponents/KalendarzModalZmienStatus.js